import { VoiceStoreState, useVoiceStore } from '../voicesStore';

export const getLatestPlayingVoiceLanguageCode = (voiceStoreState?: VoiceStoreState): string => {
  voiceStoreState ??= useVoiceStore.getState();

  const { lastPlayingVoice } = voiceStoreState;
  return lastPlayingVoice?.language || 'en';
};
